/**
 * Carousel Start Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initCarouselStart() {
    const blocks = document.querySelectorAll(".carousel-start");

    blocks.forEach((block) => {
      // Add your block functionality here
      console.log("[BLOCK] carousel-start block initialized");
    });

    // Force additional-sentence to be visible on mobile
    function ensureAdditionalSentenceVisible() {
      const isMobile = window.innerWidth < 768;
      const additionalSentenceContainers = document.querySelectorAll('.container.animate.animate-up');
      
      additionalSentenceContainers.forEach(container => {
        const hasAdditionalSentence = container.querySelector('.additional-sentence');
        if (hasAdditionalSentence && isMobile) {
          // Force in-view class on mobile to make it visible
          container.classList.add('in-view');
        }
      });
    }

    // Run on load and resize
    ensureAdditionalSentenceVisible();
    window.addEventListener('resize', ensureAdditionalSentenceVisible);
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCarouselStart);
  } else {
    initCarouselStart();
  }
})();
